document.addEventListener('alpine:init', () => {
    window.Alpine.data('navigation', () => ({
        megaMenuOpen: [],
        init() {
            this.openDropdownMobile();
        },
        toggleNavi: {
            ['@click'](){
                this.$store.globalStore.showNavi = ! this.$store.globalStore.showNavi
            }
        },
        toggleHover(index, state) {
            if(window.innerWidth >= 992) {
                this.megaMenuOpen[index] = state;
            }
        },
        openDropdownMobile() {
            if (window.innerWidth < 992) {

                const clickEvent = (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    /* Drop Down parent */
                    const dropdownMenu = e.target.closest('.dropdown');

                    /* Mega Menu */
                    const megaMenu = dropdownMenu.querySelector('.mega-menu');

                    if (!this.megaMenuOpen[megaMenu.dataset.loop]) {
                        /* open mega menu */
                        this.megaMenuOpen[megaMenu.dataset.loop] = true;
                    } else {
                        /* close mega menu */
                        this.megaMenuOpen[megaMenu.dataset.loop] = false;
                    }
                };

                /* Add event to all links */
                document.querySelectorAll(".navbar-main .dropdown > a").forEach(item =>
                        item.addEventListener("click", (e) => {
                            clickEvent(e);
                        })
                );

            }
        },
    }))
})
